import { render, staticRenderFns } from "./ShareLinks.vue?vue&type=template&id=2d395a46&scoped=true"
import script from "./ShareLinks.vue?vue&type=script&lang=js"
export * from "./ShareLinks.vue?vue&type=script&lang=js"
import style0 from "./ShareLinks.vue?vue&type=style&index=0&id=2d395a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d395a46",
  null
  
)

export default component.exports